import styled from '@emotion/styled';
import { grid } from '../../style-utils';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var FilterShowMoreWrapper = styled.div({
  margin: "".concat(grid.half().px, " 0 0 -").concat(grid.px)
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var FilterShowMoreButtonWrapper = styled.div({
  padding: "".concat(grid.half().px, " 0")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var ScrollBlock = styled.div({
  position: 'fixed',
  left: 0,
  bottom: 0,
  right: 0,
  top: 0
});